import React from "react"
import { Select } from "antd"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectPackage from "src/components/Dropdown/SelectPackage"

const FilterRequest = ({ filter, setFilter }) => {
  const handleChangeSimType = value => {
    setFilter(prev => ({ ...prev, sim_type: value }))
  }

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        maxWidth: "1000px",
      }}
    >
      <SelectCarrier
        value={filter.carrier_id}
        onChange={val => setFilter(prev => ({ ...prev, carrier_id: val }))}
        style={{ width: 150, maxWidth: "100%" }}
      />

      <SelectProvider
        value={filter.supplier_id}
        onChange={val => setFilter(prev => ({ ...prev, supplier_id: val }))}
        style={{ width: 150 }} // Giữ kích thước cố định
      />
    </div>
  )
}

export default FilterRequest
